export default {"src":"/_next/static/media/mv.0ba2f34d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};